import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Card } from '@xingternal/card';

const StyledCard = styled(Card)`
  border: none;
`;

const Layout = ({ children }) => <StyledCard>{children}</StyledCard>;

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
    .isRequired,
};

export default Layout;
